import { render, staticRenderFns } from "./ImportPropertyWizardOptionsForm.vue?vue&type=template&id=2ca12d8a&scoped=true&"
import script from "./ImportPropertyWizardOptionsForm.vue?vue&type=script&lang=js&"
export * from "./ImportPropertyWizardOptionsForm.vue?vue&type=script&lang=js&"
import style0 from "./ImportPropertyWizardOptionsForm.vue?vue&type=style&index=0&id=2ca12d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca12d8a",
  null
  
)

export default component.exports